import React, { useState, useEffect, useContext } from "react";
import SideBar from "../../../components/sidebar";
import Header from "../../../components/header";
import { Form, Button, Row, Col, Spinner } from "react-bootstrap";
import DoctorWiseReportTable from "../../../components/operator/doctor-wise-report-table";
import API_BASE_URL from "../../../config";
import { AuthContext } from "../../../utility/AuthContext";
import { authFetch } from "../../../utility/authFetch";

function DoctorWiseReport() {
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false);
  const [fromDate, setFromDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [toDate, setToDate] = useState(new Date().toISOString().split("T")[0]);
  const [report, setReport] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [loader, setLoader] = useState(false);
  const [doctor, setDoctor] = useState([]);
  const [doctorData, setDoctorData] = useState([]);
  const { user } = useContext(AuthContext);

  useEffect(() => {
    if (user.role === "Operator") {
      const fetchDoctors = async () => {
        try {
          const response = await authFetch(`${API_BASE_URL}/api/doctors`);
          const result = await response.json();
          setDoctorData(result.doctors || []);
        } catch (error) {
          console.error("Error fetching doctors:", error);
        }
      };

      fetchDoctors();
    } else {
      setDoctor(user.name);
    }
  }, [user.role, user.name]);

  return (
    <div className="d-flex">
      {loader && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{
            backgroundColor: "rgba(193, 193, 193, 0.7)",
            zIndex: 2000,
            pointerEvents: "all",
          }}
        >
          <Spinner animation="border" variant="primary" />
        </div>
      )}

      <SideBar sidebarCollapsed={sidebarCollapsed} />
      <div className="flex-grow-1">
        <Header setSidebarCollapsed={setSidebarCollapsed} />
        <div className="p-4" style={{ backgroundColor: "#f8f9fa" }}>
          <div className="container bg-white p-4 rounded shadow-sm">
            <h5>Doctor Wise Collection Report</h5>
            <Form>
              <Row className="align-item-end g-3 mb-3">
                <Col md={4}>
                  <Form.Group controlId="formDate">
                    <Form.Label>
                      From Date<span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="date"
                      name="date"
                      value={fromDate}
                      onChange={(e) => {
                        setFromDate(e.target.value);
                        setReport(false);
                        setButtonClicked(false);
                        setLoader(false);
                      }}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group controlId="formDate">
                    <Form.Label>
                      To Date<span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="date"
                      name="date"
                      value={toDate}
                      onChange={(e) => {
                        setToDate(e.target.value);
                        setReport(false);
                        setButtonClicked(false);
                        setLoader(false);
                      }}
                      required
                    />
                  </Form.Group>
                </Col>
                {(user.role === "Operator" || user.role === "Admin") && (
                  <Col md={4}>
                    <Form.Group controlId="formDoctor">
                      <Form.Label>
                        Doctor<span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Select
                        value={doctor}
                        onChange={(e) => {
                          setDoctor(e.target.value);
                          setReport(false);
                          setButtonClicked(false);
                          setLoader(false);
                        }}
                        aria-label="doctor"
                        name="doctor"
                        required
                      >
                        <option value="">Select Doctor</option>
                        {doctorData.map((doc) => (
                          <option key={doc.name} value={doc.name}>
                            {doc.name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                )}
              </Row>

              <Button
                variant="primary"
                type="button"
                disabled={buttonClicked}
                onClick={() => {
                  if (!report) {
                    setButtonClicked(true);
                    setLoader(true);
                    setReport(true);
                  }
                }}
              >
                SEARCH
              </Button>
            </Form>
          </div>
          {report && (
            <div className="container bg-white p-4 rounded shadow-sm mt-4">
              <h5 className="mb-3">
                Report for {fromDate} to {toDate}
              </h5>
              <DoctorWiseReportTable
                doctor={doctor}
                fromDate={fromDate}
                toDate={toDate}
                setLoader={setLoader}
                setButtonClicked={setButtonClicked}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default DoctorWiseReport;
